<template>
  <div class="adjust-start-form" v-loading="loading">
    <!-- {{ext1Auth}} -->
    <h3 class="minor-title margin-bottom-md"><span class="danger-text">*</span> 年度预算调整信息</h3>
    <el-form :model="submitParms" label-width="140px" size="mini">
      <el-row :gutter="20">
        <el-col :span="24">
          <section>
            <div class="inline-block margin-top-mini ">
              <span class="form-text">预算调整紧急程度：&nbsp;</span>
              <el-select
                class="mini-el-width"
                v-model="submitParms.ext3"
                @change="emitParms"
                size="mini"
                placeholder="请选择预算调整紧急程度">
                <el-option label="紧急" value="0"></el-option>
                <el-option label="一般" value="1"></el-option>
              </el-select>
            </div>
            <div class="inline-block margin-top-mini">
              <span class="form-text" >预算调整类型：&nbsp;</span>
              <el-select
                class="mini-el-width"
                v-model="ext1Type"
                @change="setExt1List"
                size="mini"
                placeholder="请选择预算调整类型">
                <el-option label="预算内调整" :value="1"></el-option>
                <el-option label="预算外调整" :value="2"></el-option>
              </el-select>
              &nbsp;
              <el-select
                class="xd-el-width"
                v-model="submitParms.ext1"
                size="mini"
                @change="changeTypeExt1()"
                placeholder="请选择预算调整类型">
                <el-option v-for="item in ext1List" 
                  :label="item.label"
                  :value="item.val" :key="item.val"></el-option>
              </el-select>
            </div>
            <div class="inline-block margin-top-mini">
              <span class="form-text" >调整年份：&nbsp;</span>
              <el-select
                class="mini-el-width"
                v-model="submitParms.alterYear"
                @change="changeYear();"
                size="mini"
                placeholder="请选择调整年份">
                <el-option v-for="item in alterYearList" 
                  :label="item"
                  :value="item" :key="item"></el-option>
              </el-select>
            </div>
            <div class="inline-block margin-top-mini" v-if="String(submitParms.ext1) === '1'">
              <span class="form-text" >预算大类：&nbsp;</span>
              <el-select
                class="mini-el-width"
                v-model="submitParms.budgetType"
                @change="changeBudgetType()"
                size="mini"
                collapse-tags
                multiple
                placeholder="请选择预算大类">
                <el-option v-for="item in budgetTypeList" 
                  :key="item.dicId" 
                  :label="item.dicName"
                  :value="item.dicId"></el-option>
              </el-select>
            </div>
            <div class="inline-block margin-top-mini" v-if="String(submitParms.ext1) === '2'">
              <span class="form-text" >预算一级部门：&nbsp;</span>
              <el-select v-model="submitParms.deptCodeList"
                filterable
                @change="changeDeptCode()"
                class="mini-el-width"
                size="mini"
                collapse-tags
                multiple
                :multiple-limit="1"
                placeholder="请选择预算一级部门"
                >
                <el-option v-for="item in firstDeptList"
                  :key="item.dicId" :label="item.dicName" :value="item.dicId"></el-option>
              </el-select>
            </div>
          </section>
        </el-col>
      </el-row>
    </el-form>
    <!-- {{ submitParms.detailList }} -->
    <!-- <alter-detail :submitParms="submitParms" :checkedBudgetTypeList="checkedBudgetTypeList" :alterType="submitParms.ext1" :detailList="submitParms.detailList" @setTitle="setTitle" @setDetailList="setDetailList"></alter-detail> -->
    <alter-detail :pageLoading="loading" :yearType="yearType"
      :year="year" :submitParms="submitParms"
      :firstDeptList="firstDeptList"
      :budgetTypeList="budgetTypeList" 
      :checkedBudgetTypeList="checkedBudgetTypeList"
      :elasticityTabList="elasticityTabList"
      :checkeDeptCodeList="checkeDeptCodeList"
      :tableDisabled="tableDisabled"
      :alterType="submitParms.ext1" 
      @delTab="delTab"
      @setTitle="setTitle" @setDetailList="setDetailList"></alter-detail>
    <!-- <h3 class="minor-title"><span class="danger-text">*</span> 预算调整明细</h3>
    <common-table :max-height="500" :getElSummaries="summaryMethod" :data="submitParms.detailList" :tableColumnData="tableColumnData" show-summary>
      <template
        slot="budgetAdjustType"
        slot-scope="{ scope }">
        {{ scope.row.budgetAdjustType  }}
      </template>
    </common-table> -->
    <!-- <div class="margin-top-sm">
      <el-button type="primary" size="mini" @click="importVisible=true">导入文件</el-button>
        <el-link class="margin-left-mid" type="primary" @click="downloadTem">下载模板</el-link>
    </div> -->
    <upload-detail :deptCodeList="submitParms.deptCodeList" 
      @setDetailListByExtType1="setDetailListByExtType1"
      @setDetailListByExtType2="setDetailListByExtType2"
      @setDetailListByExtType3="setDetailListByExtType3" 
      @setDetailListByExtType5="setDetailListByExtType5" @addDetail="addDetailByExtType3" :catIds="submitParms.budgetType" :year="submitParms.alterYear" @setLoadingTrue="setLoadingTrue" @setLoadingFalse="setLoadingFalse" :typeId="submitParms.ext1"></upload-detail>
    <el-upload
      class="upload-demo minor-title"
      action="/upload/commonUpload.json"
      :before-upload="uploadSizeLimit"
      :on-progress="()=>{loading=true;}"
      :on-success="handleSuccess"
      :on-error="()=>{loading=false;}"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      multiple
      :limit="6"
      :on-exceed="handleExceed"
      :file-list="fileList">
      <el-button size="small" :disabled="loading" icon="el-icon-upload">上传附件</el-button><span class="tip-text">单个附件大小不能超过50MB</span>
    </el-upload>
    <h3 class="minor-title">调整说明</h3>
    <el-input
      @change="emitParms"
      type="textarea"
      :rows="2"
      v-model="submitParms.msg"
      maxlength="100"
    ></el-input>
    <!-- <upload-files @setDetailList="setDetailList" uploadUrl='/budgetYearAdjustApplyDetail/importExcel.json' :importVisible.sync="importVisible"></upload-files> -->
  </div>
</template>

<script>
/**
 * 年度预算调整发起表单
 * V3.6.2：隐藏 ext1=1/3；明细导入/编辑统一 normalizeImportShareType；queryAlterMoney 使用 shareTypeNo
 */
// import UploadFiles from "../../../workbench/sumbitHalfYearTask/components/uploadFiles.vue";
import AlterDetail from "./AlterDetail.vue";
import { awaitWrapper, sleep } from "@/common/utils/assist.js"; //
import plus from 'library/functions/plus'
import {
  getShareTypeLabel,
  defaultShareTypeNo,
} from "@/modules/yearBudget/constants/shareType.js"

import { getOriTree, queryYearList, queryAlterMoney, queryGrateModey } from "../request";
import UploadDetail from "./UploadDetail.vue";
export default {
  components: {
    // UploadFiles,
    AlterDetail,
    UploadDetail
  },
  props: {
    submitParms: Object, // 调整信息
    budgetTypeList: [],
    firstDeptList: [],
    ext1Auth: []
  },
  watch: {
    submitParms: {
      handler: function(newval) {
        this.adjustInfo = JSON.parse(JSON.stringify(newval))
        if(newval.attachment) { // 附件
          this.fileList = JSON.parse(newval.attachment || '[]') 
        }
        this.emitFileList()
      },
      immediate: true,
      deep: true
    },
    '$store.state.yearBudget.isResetToDefault': {
      handler: async function(newval) {
        if (!newval) {
          return
        }
        await sleep(100)
        if (!this.alterYearList.length) {
          await this.queryYearList()
        }
        this.setExt1Type()
        var copiedYear = this.submitParms.alterYear
        if (copiedYear && this.alterYearList.includes(copiedYear)) {
          this.changeYear()
        } else {
          this.setDefaultYear()
        }
        this.$store.commit('SET_IS_RESET_TO_DEFAULT', false)
      },
      immediate: true,
      deep: true
    },
    'submitParms.budgetType': {
      handler: function(newval) {
        if(Array.isArray(newval) && newval.length > 0) {
          const checkedBudgetTypeList = (this.budgetTypeList || []).filter(item=>{
            return newval.includes(item.dicId)
          })
          this.checkedBudgetTypeList = checkedBudgetTypeList
        } else {
          this.checkedBudgetTypeList = []
        }
      },
      immediate: true,
      deep: true
    },
    'submitParms.deptCodeList': {
      handler: function(newval) {
        if (this._skipDeptCodeListSync) {
          return
        }
        if(Array.isArray(newval) && newval.length > 0) {
          const deptIdSet = newval.map(function(id) { return String(id) })
          const checkeDeptCodeList = (this.firstDeptList || []).filter(function(item) {
            return deptIdSet.indexOf(String(item.dicId)) > -1
          })
          if (checkeDeptCodeList.length > 0) {
            this.checkeDeptCodeList = checkeDeptCodeList
          } else if ((this.checkeDeptCodeList || []).length > 0) {
            return
          } else {
            this.checkeDeptCodeList = []
          }
        } else {
          this.checkeDeptCodeList = []
        }
      },
      immediate: true,
      deep: true
    },
    '$store.state.yearBudget.isEditByExtType5': {
      handler: async function(newval) {
        if (!newval) {
          return
        }
        await sleep(100)
        // console.log('111111111111')
        this.initDetailByExtType5(this.submitParms.detailList)
        this.setYearType()
        this.setExt1Type()
        this.setExt1List(this.submitParms.ext1, true)
      },
      immediate: true,
      deep: true
    },
    '$store.state.yearBudget.isEditByExtType3': {
      handler: async function(newval) {
        if (!newval) {
          return
        }
        // await sleep(100)
        this.initGrantDetail(this.submitParms.grantDetail)
        this.setYearType()
      },
      immediate: true,
      deep: true
    },
    '$store.state.yearBudget.isEditByExtType1': {
      handler: async function(newval) {
        if (!newval) {
          return
        }
        // await sleep(100)
        this.setDetailListByExtType1(this.submitParms.detailList, true)
        // this.initDetailByExtType1(this.submitParms.detailList)
        this.setYearType()
      },
      immediate: true,
      deep: true
    },
    '$store.state.yearBudget.isEditByExtType2': {
      handler: async function(newval) {
        if (!newval) {
          return
        }
        // await sleep(100)
        // console.log('333333333')
        this.setDetailListByExtType2(this.submitParms.detailList, true)
        this.setYearType()
      },
      immediate: true,
      deep: true
    },
    
  },
  computed: {
    /**
     * V3.6.2：按 ext1Type 选数据源，再按 ext1Auth 做角色级过滤
     * 原 filterExt1List + hiddenExt1 已移除（ext1List1/2 数据源不含 1/3）
     */
    ext1List() {
      const sourceList = this.ext1Type === 1 ? this.ext1List1 : this.ext1List2
      const ext1Auth = this.ext1Auth || []
      if (!ext1Auth.length) {
        return sourceList
      }
      return sourceList.filter(function(item) {
        return ext1Auth.includes(String(item.val))
      })
    },
    tableDisabled() {
      if (String(this.submitParms.ext1) === '1') {
        return !Array.isArray(this.submitParms.budgetType) || this.submitParms.budgetType.length === 0
      } else if (String(this.submitParms.ext1) === '2') {
        return !Array.isArray(this.submitParms.deptCodeList) || this.submitParms.deptCodeList.length === 0
      } else if(['3', '5'].includes(String(this.submitParms.ext1))) {
        return false
      }
      return true
    },
    
  },
  data() {
    return {
      importVisible: false, // 是否展示导入文件
      // 附件相关
      fileList: [], // 附件
      loading: false, // 全屏加载中
      ext1Type: 1, // 预算调整类型写法：1=预算内 2=预算外
      ext1List1: [
        {label: '相同一级部门调整', val: '2'},
      ],
      ext1List2: [
        // {label: '预算期间内后期预算调前期', val: '4'},
        {label: '预算外调整', val: '5'},
      ],
      alterYearList: [], // 已按月编制成功的财年或者自然年
      year: null,
      yearType: null, // 财年类型
      // budgetTypeList: [], // 预算大类
      checkedBudgetTypeList: [], // 选中预算大类
      checkeDeptCodeList: [],
      _skipDeptCodeListSync: false,
      elasticityTabList: [], // 弹性调整tab
      elasticityId: 1, // 当前弹性调整id
      tabList: [], // 调整明细tab
    };
  },
  created() {
    this.$root.previewUrl = "";
    this.$root.previewVisible = false;
    this.$root.previewName = ""
    this.setExt1Type()
    // this.getOriInfo(7) // 获取预算大类
    this.queryYearList() // 已按月编制成功的财年或者自然年

  },
  // 导入成功再emit @change="emitParms"‘；
  methods: {
    /**
     * V3.6.2：导入/编辑时补全 shareTypeNo、shareType
     * 历史数据无 shareType 时默认「否」
     * 实际需不需要两说
     */
    normalizeImportShareType(item) {
      const shareTypeNo = item.shareTypeNo || defaultShareTypeNo
      return Object.assign({}, item, {
        shareTypeNo: shareTypeNo,
        shareType: item.shareType || getShareTypeLabel(shareTypeNo),
      })
    },
    initDetailByExtType5(detailList) {
      detailList[0] = detailList[0].map(item=>{
        return this.normalizeImportShareType({
          ...item,
          cycleMonth: this.formatDateToYearMonth(item.month)
        })
      })
      this.submitParms.detailList = [detailList[0]]
      this.setBudgetCycleChange(this.submitParms.detailList[0], 0) // 循环设置金额
      this.emitParms()
    },
    addDetailByExtType3() { // 添加调整明细

      const elasticityId = ++this.elasticityId
      this.elasticityTabList.push({dicId: elasticityId, dicName: '调整明细'})
      this.submitParms.detailList.push([{tabId: elasticityId}])
      this.emitParms()
    },
    async changeDeptCode() {
      // this.checkedBudgetTypeList = [] // 清空相同预算大类的数据
      // this.submitParms.budgetType = []
      // await this.$nextTick()
      this.emitParms()

    },
    async queryYearList() {
      this.loading = true
      let [, res] = await awaitWrapper(queryYearList())
      this.loading = false
      if (res && res.code == 0) {
        this.alterYearList = res.data || []
        if (!this.$route.query.id) {
          this.setDefaultYear()
        }
      }
    },
    setLoadingTrue() {
      this.loading = true
    },
    setLoadingFalse() {
      this.loading = false
    },
    setDefaultYear() {
      let yearList = this.alterYearList.map(item=>{
        return {
          initName: item,
          year: parseInt(item.slice(0, 4))
        }
      }).sort((a, b)=> {
        if (b.year !== a.year) {
            return b.year - a.year; // 降序，最新年份排在前面
        }
        if (b.initName.includes('自然年')) {
            return 1; // b含自然年，b排在前面
        } else if (a.initName.includes('自然年')) {
            return -1; // a含自然年，a排在前面
        }
        return 0;
      })
      if (yearList.length > 0) {
        this.submitParms.alterYear = yearList[0].initName
        this.changeYear()
      }
    },
    initGrantDetail(successList) { // 编辑初始化
      const detailList = []
      const detailObj = {}
      const tabList = [];
      // 根据一级部门合并想要的数据。谢谢
      successList.forEach(item => {
          const key = item.firstDeptId + '_' + item.subjectsCatId + '_' + item.subjectsTypeId + '_' + item.businessUnitId
          if (detailObj[key]) {
              detailObj[key].push({
                ...item,
                tabId: detailObj[key][0].tabId
              })
          } else {
            this.elasticityId++
            detailObj[key] = [{
              ...item,
              tabId: this.elasticityId
            }]
          }
      })
      Object.keys(detailObj).forEach((key, index) => {
          detailList.push(detailObj[key])
          tabList.push({
            dicId: detailObj[key][0].tabId,
            dicName: '调整明细'
          })
      })
      this.elasticityTabList = tabList
      this.submitParms.detailList = detailList
      if (Array.isArray(detailList) && detailList.length > 0) {
        detailList.forEach((currTableData, listIndex)=>{
          this.setCycleGrantedAmount(currTableData, listIndex) // 循环设置已授予金额和待授予金额
        })
      }
      this.emitParms()
    },
    setCycleGrantedAmount(currTableData, listIndex) {
      const promiseList = currTableData.map((item)=>{
          const params = {
            firstDeptId: item.firstDeptId,
            subjectsCatId: item.subjectsCatId,
            subjectsTypeId: item.subjectsTypeId,
            businessUnitId: item.businessUnitId,
            budgetCycle: item.budgetCycle,
          }
          return queryGrateModey(params)
      })
      Promise.all(promiseList).then((totalRes) => {
      if (Array.isArray(totalRes)) {
          totalRes.forEach((res, rowIndex) => {
            if (res && res.data) {
              // 待授予金额
              this.$set(this.submitParms.detailList[listIndex][rowIndex], 'pendingGrantedAmount', res.data.pendingGrantedAmount || null)
              // 已授予金额
              this.$set(this.submitParms.detailList[listIndex][rowIndex], 'grantedAmount', res.data.grantedAmount || null)
            }
          })
        }
        this.emitParms()
      })
    },
    setDetailListByExtType5(successList, isEdit) { // 预算外调整
      // V3.6.2：导入后补全 shareTypeNo，并触发 queryAlterMoney(shareTypeNo)
      successList.forEach(item => {
        item.cycleMonth = this.formatDateToYearMonth(item.month)
      })
      const normalizedList = successList.map(item => this.normalizeImportShareType(item))
      this.submitParms.detailList = [[...normalizedList]]
      this.setBudgetCycleChange(successList, 0) // 循环设置金额
      this.emitParms()
    },
    async setDetailListByExtType2(successList, isInit) {
      // V3.6.2：相同一级部门调整，按一级部门分 tab，行数据含 shareTypeNo
      const flatList = []
      if (Array.isArray(successList)) {
        successList.forEach(function(item) {
          if (Array.isArray(item)) {
            item.forEach(function(row) {
              if (row) {
                flatList.push(row)
              }
            })
          } else if (item) {
            flatList.push(item)
          }
        })
      }
      const detailList = []
      const detailObj = {}
      const tabList = []
      flatList.forEach(item => {
          item.cycleMonth = this.formatDateToYearMonth(item.month)
          const normalizedItem = this.normalizeImportShareType(item)
          if (detailObj[normalizedItem.firstDeptId]) {
              detailObj[normalizedItem.firstDeptId].push(normalizedItem)
          } else {
              detailObj[normalizedItem.firstDeptId] = [normalizedItem]
          }
      })
      Object.keys(detailObj).forEach((key, index) => {
          detailList.push(detailObj[key])
          tabList.push({
            dicId: detailObj[key][0].firstDeptId,
            dicName: detailObj[key][0].firstDeptName
          })
      })
      const deptTabList = this.buildDeptTabListFromImport(tabList)
      this._skipDeptCodeListSync = true
      this.submitParms.detailList = detailList
      this.submitParms.deptCodeList = tabList.map(function(item) {
        return item.dicId
      })
      this.checkeDeptCodeList = deptTabList
      const self = this
      this.$nextTick(function() {
        self._skipDeptCodeListSync = false
        if (Array.isArray(detailList) && detailList.length > 0) {
          detailList.forEach(function(currTableData, listIndex) {
            self.setBudgetCycleChange(currTableData, listIndex)
          })
        }
        self.emitParms()
      })
    },
    buildDeptTabListFromImport(tabList) {
      const firstDeptList = this.firstDeptList || []
      return (tabList || []).map(function(tab) {
        const matched = firstDeptList.find(function(item) {
          return String(item.dicId) === String(tab.dicId)
        })
        if (matched) {
          return matched
        }
        return {
          dicId: tab.dicId,
          dicName: tab.dicName,
        }
      })
    },
    setDetailListByExtType1(successList, isInit) {
      const detailList = []
      const detailObj = {}
      this.checkedBudgetTypeList = [];
      // 根据一级部门合并想要的数据。谢谢
      successList.forEach(item => {
          item.cycleMonth = this.formatDateToYearMonth(item.month)
          const normalizedItem = this.normalizeImportShareType(item)
          if (detailObj[normalizedItem.subjectsCatId]) {
              detailObj[normalizedItem.subjectsCatId].push(normalizedItem)
          } else {
              detailObj[normalizedItem.subjectsCatId] = [normalizedItem]
          }
      })
      Object.keys(detailObj).forEach((key, index) => {
          detailList.push(detailObj[key])
          this.checkedBudgetTypeList.push({
            dicId: detailObj[key][0].subjectsCatId,
            dicName: detailObj[key][0].subjectsCatName
          })
      })
      if (isInit) {
        this.submitParms.budgetType = (this.checkedBudgetTypeList || []).map(item=>{
          return item.dicId
        })
      } 
      // console.log('4555555555555555554')

      this.submitParms.detailList = detailList
      if (Array.isArray(detailList) && detailList.length > 0) {
        detailList.forEach((currTableData, listIndex)=>{
          this.setBudgetCycleChange(currTableData, listIndex) // 循环设置金额
        })
      }
      // this.emitParms()
    },
    changeBudgetType() {
      this.emitParms();
      // this.setDetailTableByDudgetType(); //
    },
    changeTypeExt1() {
      this.clearDetailList()
      this.setExt1Type();
      this.initDetailList();
      this.emitParms()
    },
    changeYear() {
      this.clearDetailList();
      this.setYearType();
      this.emitParms()
    },
    // async getOriInfo(type) { // 获取预算大类
    //     this.loading = true
    //     let [, res] = await awaitWrapper(getOriTree({
    //         dataType: type
    //     }))
    //     this.loading = false
    //     if (!res || res.code != 0) {
    //         return
    //     }
    //     // if (type == 1) {
    //     //     // 暂时只有一个主体华图教育科技
    //     //     this.belongToList = res.data.tree[0].childrens || []
    //     //     if (Array.isArray(this.belongToList) && this.belongToList.length > 0) {
    //     //         this.belongTo = this.belongToList[0].dicId
    //     //         this.tenantId = res.data.tree[0].dicId  // 主体id
    //     //     }
    //     //     // this.setSesponsibilityCenterList()
    //     // } if (type == 6) {
    //     //     this.firstDeptList = res.data.tree || [] // 
    //     // } else 
    //     if (type == 7) {
    //         this.budgetTypeList = res.data.tree || []
    //     }
    //     // else if (type == 8) {
    //     //     this.bussinessList = res.data.tree || []
    //     // } else if (type == 3 || type == 4) { // 年度半年度
    //     //     this.dimensionList = res.data.tree || []
    //     // }
    // },
    clearDetailList() {
      ++this.elasticityId
      // TODO 这个交给子组件 AlterDetail 处理，需要排查table数据
      if ((String(this.submitParms.ext1) === '1' && this.submitParms.budgetType)
      ) {
        // console.log('45555555555555555546')

        this.submitParms.detailList = this.submitParms.detailList.map(currDetailList=>{
          if (currDetailList && currDetailList.length > 0) {
            return currDetailList.map(item=>{
              return {
                subjectsCatId: item.budgetType
              }
            })
          } else {
            return currDetailList
          }
        })
      } else if (String(this.submitParms.ext1) === '5') {
        this.submitParms.detailList = [[{}]]
      } else if(String(this.submitParms.ext1) === '3') {
        this.submitParms.detailList = [[{tabId: this.elasticityId}]]
        this.elasticityTabList = [{dicId: this.elasticityId, dicName: '调整明细'}]
      } else {
        // console.log('455555555555555555465')

        this.submitParms.detailList = [[{}, {}]]
      }

      this.checkedBudgetTypeList = []
      this.checkeDeptCodeList = []
      this.elasticityTabList = []
      this.submitParms.deptCodeList = []
      this.submitParms.budgetType = []
      this.emitParms()
    },
    setYearType() {
      if (this.submitParms.alterYear) {
        this.yearType = this.submitParms.alterYear.includes('自然年') ? 1 : 2
        this.year = this.submitParms.alterYear.slice(0, 4)
      } else {
        this.yearType = null
        this.year = null
      }
      // console.log('this.yearType', this.yearType)
    },
    setExt1Type() {
      if(['1','2','3'].includes(this.submitParms.ext1)) {
        this.ext1Type = 1
      } else if(['4','5'].includes(this.submitParms.ext1)){
        this.ext1Type = 2
      }
    },
    setExt1List(val, isEdit) { // 设置"预算调整类型"具体选项
      // 编辑历史草稿时，若 ext1 为已隐藏类型则回退到首个可用选项
      if (isEdit && val && ['1', '3'].includes(String(val))) {
        this.submitParms.ext1 = this.ext1List.length > 0 ? this.ext1List[0].val : null
      } else {
        this.submitParms.ext1 = isEdit ? val : null
      }
      if (!isEdit) {
        this.checkedBudgetTypeList = []
        this.checkeDeptCodeList = []
        this.elasticityTabList = []
      }
    },
    setTitle(val) {
      this.submitParms.title = val
      this.$emit("setSubmitParms", this.submitParms)
    },
    initDetailList() {
      this.submitParms.title = '年度预算调整流程'
      ++this.elasticityId
      // console.log('4555555555555555554655')

      // TODO 后续要根据 员工薪酬根据类型判断
      if( String(this.submitParms.ext1) == '5') {
        this.submitParms.detailList = [[{}]]
      } else if(String(this.submitParms.ext1) === '3') {
        this.submitParms.detailList = [[{tabId: this.elasticityId}]]
        this.elasticityTabList = [{dicId: this.elasticityId, dicName: '调整明细'}]
      } else {
        this.submitParms.detailList = [[{}, {}]]
      }
    },
    setDetailList(val) {
      // console.log('455555555555555555465563')
      const { detailList, index } = val
      if (index == -1) {
        if (!detailList || detailList.length === 0) {
          this.initDetailList()
        } else {
          this.submitParms.detailList = JSON.parse(JSON.stringify(detailList || []))
        }
        // this.submitParms.detailList = JSON.parse(JSON.stringify(detailList || []))
      } else {
        this.submitParms.detailList[index] = JSON.parse(JSON.stringify(detailList || []))
      }
      this.$emit("setSubmitParms", this.submitParms)
    },
    // downloadTem() {
    //   window.open(`/upload/download.json?name=预算调整模板.xlsx&url=https://htwuhan.oss-cn-beijing.aliyuncs.com/wangxiao/ba1e23a9b7c847da9680de6cbc4f1ffb.xlsx`)
    // },
    emitParms() {
      this.$emit("setSubmitParms", this.submitParms)
    },
    emitFileList() {
      this.$emit("setFileList", this.fileList)
    },
    dealWithMoney(value) {
      if (!value) {
        return "--";
      } else {
        return this.$options.filters.currency(
          this.$options.filters.unitMoney(value, 1),
          "￥",
          2
        );
      }
    },
    uploadSizeLimit(file) {
        if (file.size > 50 * 1024 * 1024) {
            this.$alert('单个附件大小不能超过50M', '提示', {
                type: 'warning'
            })
            return false
        }
        return true
    },
    /**
     * V3.6.2：预算周期变更后批量查询「调整前金额」
     * queryAlterMoney 入参由 businessUnitId 改为 shareTypeNo
     */
    setBudgetCycleChange(currTableData, listIndex) {
      // console.log('listIndex', listIndex)
      const promiseList = currTableData.map((item)=>{
          const { year, month } = this.getCycleYearAndMonth(item.cycleMonth || item.month)
          const params = {
            firstDeptId: item.firstDeptId,
            subjectsCatId: item.subjectsCatId,
            subjectsTypeId: item.subjectsTypeId,
            shareTypeNo: item.shareTypeNo || defaultShareTypeNo,
            year,
            month,
          }
          return queryAlterMoney(params)
      })
      Promise.all(promiseList).then((totalRes) => {
      if (Array.isArray(totalRes)) {
          totalRes.forEach((res, rowIndex) => {
          // console.log('rowIndex', rowIndex)
            if (res && res.data) {
              let adjustAmount = this.submitParms.detailList[listIndex][rowIndex].adjustAmount
              this.submitParms.detailList[listIndex][rowIndex].budgetAmount = res.data.budgetAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].adjustBeforeAmount = res.data.adjustBeforeAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].budgetImplementedAmount = res.data.budgetImplementedAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].freezeAmount = res.data.freezeAmount || 0;
              // this.submitParms.detailList[listIndex][rowIndex].adjustAfterRemainAmount = res.data.afterPendingGrantedAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].initAdjustBeforeAmount = res.data.adjustBeforeAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].remainAmount = res.data.remainAmount || 0;
              this.submitParms.detailList[listIndex][rowIndex].adjustAfterRemainAmount = plus( adjustAmount || 0, res.data.remainAmount || 0)
              this.$set(this.submitParms.detailList[listIndex], rowIndex, this.submitParms.detailList[listIndex][rowIndex])
              // console.log('this.submitParms.detailList[listIndex][rowIndex].afterPendingGrantedAmount', this.submitParms.detailList[listIndex][rowIndex].afterPendingGrantedAmount)
            }
          })
        }
        // console.log('this.submitParms.detailList', this.submitParms.detailList)
        this.emitParms()
      })
    },
    getCycleYearAndMonth(currMonth) {
      // console.log('currMonth', currMonth)
      if (currMonth) {
        let year = currMonth.split('_')[0]
        let month = currMonth.split('_')[1]
        let cycleMonth = `${year}年${month}月`
        let cycleYear = `${year}${this.yearType == 1 ? '自然年' : '财年'}`
        return {
          month: cycleMonth,
          year: cycleYear
        }
      }
    },
    // 添加日期格式转换函数
    formatDateToYearMonth(dateStr) {
        if (!dateStr) return '';
        const match = dateStr.match(/(\d{4})年(\d{1,2})月/);
        if (match) {
            const year = match[1]
            const month = match[2] // 确保月份是两位数
            return `${year}_${month}`;
        }
        return '';
    },
    // 处理上传的表格，tabid用来匹配，不可删除
    setDetailListByExtType3(successList) {
      const detailList = []
      const detailObj = {}
      this.elasticityTabList = [];
      // 根据一级部门合并想要的数据。谢谢
      successList.forEach(item => {
          const key = item.firstDeptId + '_' + item.subjectsCatId + '_' + item.subjectsTypeId + '_' + item.businessUnitId
          console.log('successList key', key)
          if (detailObj[key]) {
              detailObj[key].push({
                ...item,
                grantedMonth: item.grantedMonth ? this.formatDateToYearMonth(item.grantedMonth) : null,
                pendingGrantedMonth: item.pendingGrantedMonth ? this.formatDateToYearMonth(item.pendingGrantedMonth) : null,
                tabId: detailObj[key][0].tabId
              })
          } else {
              this.elasticityId++
              detailObj[key] = [{
                ...item,
                grantedMonth: item.grantedMonth ? this.formatDateToYearMonth(item.grantedMonth) : null,
                pendingGrantedMonth: item.pendingGrantedMonth ? this.formatDateToYearMonth(item.pendingGrantedMonth) : null,
                tabId: this.elasticityId
              }]
          }
      })
      Object.keys(detailObj).forEach((key, index) => {
          detailList.push(detailObj[key])
          this.elasticityTabList.push({
            dicId: detailObj[key][0].tabId,
            dicName: '调整明细'
          })
      })
      // console.log('45555555555555555546556344')

      this.submitParms.detailList = detailList
      // TODO 准备直接算钱。。。太无语了；
      // this.$store.commit('SET_IS_IMPORT_TYPE3_DETAIL_LIST', true)
      this.emitParms()
    },
    handleSuccess(res,file,list){
        const { code, data, msg } = res;
        if(code===0){
            for(let item of list){
                if(item.response){
                    item.url = item.response.data.url;
                }
            }
            this.fileList = list.map(item=>{
                return {
                    name:item.name,
                    url:item.url,
                    uid:item.uid
                }
            });
            this.emitFileList()
            this.loading = false;
            this.$message.success('上传成功')
        }else{
            const uid = file.uid;
            const index = list.findIndex(item=>item.uid===uid);
            if(index>-1){
                list.splice(index,1);
            }
            this.loading = false;
            this.emitFileList()
            this.$message.error(msg||'上传失败')
        }
    },
    handlePreview(file) {
        const url = file.url;
        if(url){
            const imgReg = /\.(jpe?g|png|svg|gif|bmp)$/i;
            if(imgReg.test(url)){
                this.$root.previewUrl = url;
                this.$root.previewVisible = true;
                this.$root.previewName = file.name
            }else{
                window.open(url);
            }
        }
    },
    beforeRemove(file, fileList) {
        if(file.status === 'success'){
            return this.$confirm(`确定移除 ${ file.name }？`,{type:'warning'});
        }
    },
    delTab(targetId) { // 删除tab
      // console.log('4555555555555555554655e3e3')

      const targetIndex = this.elasticityTabList.findIndex(item=>item.dicId == targetId)
      this.submitParms.detailList.splice(targetIndex, 1)
      this.elasticityTabList.splice(targetIndex, 1)
      this.emitParms()
    },
    handleRemove(file, list) {
      const url = file.url;
      const index = this.fileList.findIndex(item=>item.url===url)
      if(index>-1){
          this.fileList.splice(index,1);
          this.emitFileList()
      }
    },
    handleExceed (files, list) {
      this.$alert('最多只能上传5个附件', '提示', {
          type: 'warning'
      })
    },
   
  },
};
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
}
.adjust-start-form {
  min-width: 800px;
}
.mid-el-width {
  width: 200px;
}
.mini-el-width {
  width: 200px;
}
.xd-el-width {
  width: 280px;
}
.form-text {
  display: inline-block;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #262626;
}
.margin-left-mid {
  margin-left: 15px;
}
.margin-top-sm {
  margin-top: 10px;
}
.sm-el-width {
  width: 100px;
}
.tip-text {
  margin-left: 6px;
  font-size: 12px;
  font-weight: normal;
  color: #aaa;
}
.margin-top-mini {
  margin-top: 5px
}
.margin-bottom-md {
  margin-bottom: 11px
}
</style>